import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import Menu from './menu/Menu';
import Home from './pages/Home';
import Detail from './pages/events/Detail';
import QueueGuard from './pages/queue/QueueGuard';
import DetailNews from './pages/news/Detail';
import AllEvents from './pages/events/AllEvents';
import AllNews from './pages/news/AllNews';
import ScrollToTop from './helpers/ScrollToTop';
import Payment from './pages/payment/Payment';
import TicketDetails from './pages/tickets/TicketDetails';
import Register from './pages/payment/Register';
import { Toaster } from 'react-hot-toast';
import MyTickets from './pages/customer/MyTickets';
import FAB from './components/FAB';
import MyAccount from './pages/account/MyAccount';
import { AppProvider } from './context/AppContext';
import MyTicketDetails from './pages/tickets/MyTicketDetails';
import ResetPassword from './pages/ResetPassword';
import ErrorBoundary from './components/ErrorBoundary';
import NotFound from './pages/NotFound';
import Terminos from './pages/legal/Terminos';
import Privacidad from './pages/legal/Privacidad';

function App() {
  useEffect(() => {
    document.title = "Monoticket";
  }, []);

  return (
    <ErrorBoundary>
    <Router>
      <AppProvider>
        <ScrollToTop />
        <Toaster
          position="bottom-center"
          toastOptions={{
            style: {
              background: '#0f0e17',
              color: '#fff',
              border: '1px solid #333',
            },
            success: {
              duration: 2000,
              style: {
                background: '#1a1a1a',
                borderLeft: '5px solid #2ecc71',
              },
              iconTheme: {
                primary: '#2ecc71',
                secondary: '#0f0e17',
              },
            },
            error: {
              duration: 2000,
              style: {
                background: '#1a1a1a',
                borderLeft: '5px solid #ff1e01',
              },
              iconTheme: {
                primary: '#ff1e01',
                secondary: '#0f0e17',
              },
            },
          }}
        />
        <Routes>
          <Route path="/" element={<Menu />}>
            <Route index element={<Home />} />
            <Route path="/event/detail/:id" element={<QueueGuard><Detail /></QueueGuard>} />
            <Route path="/events" element={<AllEvents />} />
            <Route path="/news/detail/:id" element={<DetailNews />} />
            <Route path="/news" element={<AllNews />} />
            <Route path="/payment/:holdId" element={<Payment />} />
            <Route path="/tickets/:transaction" element={<TicketDetails />} />
            <Route path="/mytickets/detail/:purchaseId" element={<MyTicketDetails />} />
            <Route path="/mytickets" element={<MyTickets />} />
            <Route path="/myaccount" element={<MyAccount />} />
            <Route path="/terminos" element={<Terminos />} />
            <Route path="/privacidad" element={<Privacidad />} />
          </Route>
          <Route path="/payment/register/:holdId" element={<Register />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <FAB />
      </AppProvider>
    </Router>
    </ErrorBoundary>
  );
}

export default App;
